var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-modal',_vm._g({ref:"modal"},_vm.$listeners),[_c('div',{staticClass:"modal__image"},[_c('a',{attrs:{"href":_vm.image,"target":"_blank","title":"Open in new tab"}},[_c('v-pdf-viewer',{attrs:{"src":_vm.image}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }